











import Vue from 'vue'
import { nl2br } from '@/utils'

export default Vue.extend({
  name: 'FAQItem',
  props: {
    question: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    formatText: (s: string): string => {
      return nl2br(s.replace(/\[(.+)\]\((.+)\)/g, '<a style="color: #469fd6" href="$2" target="_blank">$1</a>'))
    },
    handleClick: function(e: Event) {
      e.preventDefault()
      this.$emit('handleClick')
    }
  }
})
